// extracted by mini-css-extract-plugin
export default {"rowWrapper":"ScoreTile_rowWrapper__vmjky","iconWrapper":"ScoreTile_iconWrapper__XVcwf","tileWrapper":"ScoreTile_tileWrapper__ZRUKT"};